var React = require('react');

function GlobalProfileOverriden (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E93349","fillRule":"evenodd","d":"M12 0 7 3l5 3V4.062c3.946.492 7 3.858 7 7.938h2c0-5.185-3.947-9.449-9-9.95V0Zm0 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 8h3l-1 6h-1l-1-6Zm13.182 7.269a1 1 0 0 1 .05 1.413L16.4 23.466l-3.131-3.355a1 1 0 0 1 1.462-1.365l1.669 1.788 4.869-5.216a1 1 0 0 1 1.413-.05ZM5.14 3.896A9.987 9.987 0 0 0 1 12c0 5.523 4.477 10 10 10v-2A8 8 0 0 1 6.947 5.101L5.14 3.896Z","clipRule":"evenodd"}));
}

GlobalProfileOverriden.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = GlobalProfileOverriden;

GlobalProfileOverriden.default = GlobalProfileOverriden;
